<template>
  <div>
    <el-dialog title="添加备注" :visible.sync="showDialog" append-to-body width="600px">

      <el-form ref="formDataRef" :model="formData" inline :rules="rules">
        <el-form-item label="承运商备注" prop="carrierRemark">
          <el-input v-model="formData.carrierRemark" type="textarea" clearable style="width:450px"></el-input>
        </el-form-item>

      </el-form>
      <template #footer>
        <el-button type="primary" @click="onSubimt">提交</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showDialog: false,
      formData: {
        carrierRemark: "",
        dispatcherId: ""
      },
      rules: { carrierRemark: [{ required: true, message: "请输入" }] }
    };
  },

  methods: {
    openDialog(dispatcherId, carrierRemark) {
      this.formData.dispatcherId = dispatcherId;
      this.formData.carrierRemark = carrierRemark;
      this.showDialog = true;
    },
    async onSubimt() {
      let valid = await this.$refs["formDataRef"].validate();
      if (!valid) return;
      let url = "http://MID-OPERATE-LOGISTICS/messageService/carrierProxyService/carrierWriteRemark";
      this.cfmInvoke(url, { dispatcherInfo: this.formData }).then(() => {
        this.$message.success("操作成功");
        this.showDialog = false;
        this.formData.carrierRemark = "";
        this.$emit("onFinish");
      });
    }
  }
};
</script>